module.exports = __webpack_public_path__ + "img/bayked.c4ad6bdd.png";